import { IQuickVideo } from 'lib/api/quickVideo/types';
import { useDeleteQuickVideoMutation } from 'lib/api/quickVideo/useDeleteQuickVideoMutation';
import { NewModal } from 'lib/components';
import { Gap } from 'lib/components/styles/layout';
import React from 'react';
import { Button } from 'react-covideo-common';
import { Trans, useTranslation } from 'react-i18next';

type DeleteModalProps = {
  quickVideo: IQuickVideo;
  onClose: () => void;
};

const DeleteQuickVideoModal = ({ quickVideo, onClose }: DeleteModalProps) => {
  const { t } = useTranslation();
  const { mutateAsync: deleteQuickVideoMutation, isLoading: isDeleting } =
    useDeleteQuickVideoMutation({
      closeModalHandler: onClose,
    });
  const onDelete = async () => {
    await deleteQuickVideoMutation(quickVideo.quickVideoId);
  };
  return (
    <NewModal closeModal={onClose} headerText={t('Delete Quick Video')}>
      <Gap flexDirection='column' gap='24px' alignItems='flex-start'>
        <div>
          <Trans
            i18nKey='quickVideoDeleteConfirmation'
            values={{ name: quickVideo.name }}
          />
        </div>
        <Gap justifyContent='flex-end' width='100%'>
          <Button
            variant='secondary'
            disabled={isDeleting}
            onClick={onClose}
            text={t('Cancel')}
          />
          <Button
            variant='destructive'
            disabled={isDeleting}
            onClick={onDelete}
            text={t('Delete')}
          />
        </Gap>
      </Gap>
    </NewModal>
  );
};

export default DeleteQuickVideoModal;
